import { render, staticRenderFns } from "./storage-sys-switch.vue?vue&type=template&id=697ecf5c"
import script from "./storage-sys-switch.vue?vue&type=script&lang=js"
export * from "./storage-sys-switch.vue?vue&type=script&lang=js"
import style0 from "./storage-sys-switch.vue?vue&type=style&index=0&id=697ecf5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports